"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("../../../context");
var utils_1 = require("../../../utils");
var Card_1 = require("../../Card");
var FormControl_1 = __importDefault(require("../../FormControl"));
var FormProvider_1 = require("../../FormProvider");
var Select_1 = __importDefault(require("../../Select"));
var Tabs_1 = require("../../Tabs/Tabs");
var Fields_1 = require("../Fields");
var errorKeys = ['title', 'first_name', 'last_name', 'gender', 'dob', 'age', 'sexuality'];
var PersonalDetailsForm = function (_a) {
    var tabId = _a.tabId;
    var _b = context_1.useSemantics(), trans = _b.trans, options = _b.options;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = FormProvider_1.useFormContext().errors;
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(errors, errorKeys)); }, [errors]);
    var titles = react_1.useMemo(function () { return options.titles(); }, []);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('optiiva::headings.personal'), subHeading: trans('optiiva::headings.details') },
        react_1.default.createElement(FormControl_1.default, { errors: errors.title, dusk: "title-field", label: trans('optiiva::labels.title') },
            react_1.default.createElement(Select_1.default, { width: "xs", options: titles, name: "title" })),
        react_1.default.createElement(Fields_1.FirstNameInput, null),
        react_1.default.createElement(Fields_1.LastNameInput, null),
        react_1.default.createElement(FormControl_1.default, { errors: errors.gender, dusk: "gender-field", label: trans('optiiva::labels.gender') },
            react_1.default.createElement(Select_1.default, { width: "xs", options: options.genders(), name: "gender" })),
        react_1.default.createElement(Fields_1.DateOfBirthAgeInput, null),
        react_1.default.createElement(FormControl_1.default, { errors: errors.sexuality, dusk: "sexuality-field", label: trans('optiiva::labels.sexuality') },
            react_1.default.createElement(Select_1.default, { width: "xs", options: options.sexualOrientations(), name: "sexuality" }))));
};
exports.default = PersonalDetailsForm;
//# sourceMappingURL=PersonalDetailsForm.js.map